import { DEACTIVATED, WORKFLOWS_ASSIGNMENT_ACCESS } from 'automation-ui-action-features/constants/Scopes';
import http from 'hub-http/clients/apiClient';
import memoize from 'transmute/memoize';

// There is a service type for this API, but it's simple enough to do in-house.
// https://git.hubteam.com/HubSpot/customer-success/blob/f8c046370760be215105f339ba71d84057c31a1e/customer-success-client-types/static/js/UsersService-v2/types.ts#L24-L25

export const fetchAssignableUserIds = memoize(() => http.get(`users/v2/app/scopes/${WORKFLOWS_ASSIGNMENT_ACCESS}/user-ids`));
export const fetchDeactivatedUserIds = memoize(() => http.get(`users/v2/app/scopes/${DEACTIVATED}/user-ids`));